export default "__VITE_ASSET__BemkDcDr__"